import { type ToastProps } from './Toast';
import ToastEvents from './ToastEvents';

const ErrorToast = (text: string, options?: ToastProps) => {
  ToastEvents.show({
    title: 'Error!',
    text,
    type: 'error',
    persist: true,
    ...options
  });
};

export default ErrorToast;
